export default __webpack_public_path__ + "static/media/FlatGenericLogoFullSize.c717b55a.png";